import { Dayjs } from "dayjs";

export const END_OF_DAY_TIME = "23:59:59";
export const START_OF_DAY_TIME = "00:00:00";

export const setEndOfDay = (date: Dayjs): Dayjs => {
  return date.hour(23).minute(59).second(59);
};

export const setStartOfDay = (date: Dayjs): Dayjs => {
  return date.hour(0).minute(0).second(0);
};

export const formatDateForSubmission = (date: Dayjs): string => {
  return date.format("YYYY-MM-DDTHH:mm:ss");
};

export const handleEndDateChange = (selectedEndDate: Dayjs | null, startDate: string): string => {
  if (!selectedEndDate) return "";

  return formatDateForSubmission(setEndOfDay(selectedEndDate));
};

export const handleStartDateChange = (selectedStartDate: Dayjs | null): string => {
  if (!selectedStartDate) return "";

  return formatDateForSubmission(setStartOfDay(selectedStartDate));
};
